export const admin = (user) => user.role === 'ROLE_ADMIN';
export const office = (user) => user.role === 'ROLE_OFFICE';
export const base = (user) => user.role === 'ROLE_DEFAULT';
export const externalLegal = (user) => user.role === 'ROLE_EXTERNAL_LEGAL';
export const external = (user) => user.role === 'ROLE_EXTERNAL';
export const collaborator = (user) => user.role === 'ROLE_DEFAULT';
export const isSuper = (user) => admin(user) || office(user);
export const company = (user) => isSuper(user) || base(user);
